import { User } from '../../core/models/user'
import { Version } from '../../core/models/version'
import { alias, AliasedConstructor } from '../../rest/decorators/alias'
import { RestQuery } from '../../rest/utilities/rest-query'
import {
  DynamicBinding,
  Serialisable,
  SerialisationConfig,
} from '../../rest/utilities/serialisable'

export class Customer extends Serialisable {
  public static override serialisationConfig: SerialisationConfig =
    new SerialisationConfig(() => new Customer(), {
      salesPerson: new SerialisationConfig(() => new User()),
      firstVersion: new SerialisationConfig(() => new Version()),
      lastVersion: new SerialisationConfig(() => new Version()),
      currentVersion: new SerialisationConfig(() => new Version()),
    })

  @alias('id')
  id!: number
  @alias('numeric_id')
  numericID!: number
  @alias('name')
  name!: string
  @alias('is_internal')
  internal!: boolean
  @alias('address')
  address!: string
  @alias('phone')
  phone!: string
  @alias('website')
  website!: string
  @alias('source')
  source!: string
  @alias('status')
  status = 'Client'
  @alias('sales_person')
  salesPerson!: User
  @alias('comments')
  comments!: string
  @alias('first_version')
  firstVersion!: Version | null
  @alias('latest_version')
  lastVersion!: Version | null
  @alias('current_version')
  currentVersion!: Version | null
  @alias('stop')
  stop!: boolean
  @alias('deleted')
  deleted!: boolean

  constructor() {
    super((Customer as unknown as AliasedConstructor)._alias)
  }

  override serialise(): object {
    const data = super.serialise() as DynamicBinding
    if (Object.prototype.hasOwnProperty.call(data, 'sales_person')) {
      data['sales_person_id'] = this.salesPerson?.numericID ?? null
      delete data['sales_person']
    }
    if (data['first_version']) {
      delete data['first_version']
    }
    if (data['last_version']) {
      delete data['last_version']
    }
    if (data['current_version']) {
      delete data['current_version']
    }
    return data
  }

  static create<Data>(attrs: Data) {
    return new Customer().update(attrs, Customer.serialisationConfig)
  }
}

interface Filters {
  keywords?: string
  user?: number
  status?: string
  archive?: string
}
type Ordering = 'name' | '-name' | 'phone' | '-phone' | 'status' | '-status'
type Includes = 'salesPerson'

export class CustomerQuery extends RestQuery<Filters, Ordering, Includes> {}
